import z from "zod";
import { mapErrorsToFields } from "../../../../utils";
import ExerciseLoadTypeService from "../../../../services/ExerciseLoadTypeService";

const api = new ExerciseLoadTypeService();
export type State = {
  errors?: {
    name?: string[];
    orderNumber?: string[];
    general?: string[];
  };
  message?: string | null;
  success?: boolean;
  defaultValues?: {
    name?: string;
    orderNumber?: number;
  };
};
const FormSchema = z.object({
  name: z.string().min(1, "Name is required."),
  orderNumber: z.int().min(1, "Order Number is required."),
});

export async function addLoadType(
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() ?? "",
    orderNumber: parseInt( formData.get("orderNumber")?.toString() ?? "1"),
  };
  console.log({defaultValues})
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);

    if (!validatedFields.success) {
      return {
        success: false,
        errors: mapErrorsToFields(validatedFields.error),
        message: "Missing Fields. Failed to Create Exercise Load Type.",
      };
    }
    const { name , orderNumber} = validatedFields.data;

    const result = await api.addExerciseLoadType({ name , orderNumber: Number(orderNumber) });
    if (result.status == 201)
      return {
        message: "Exercise Load Type created successfully.",
        success: true,
        defaultValues: defaultValues,
        errors: {},
      };
    else
      return {
        message: "Failed to create exercise load type.",
        success: false,
        errors: {},
        defaultValues: defaultValues,
      };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to create exercise load type.",
      success: false,
      errors: {},
      defaultValues: defaultValues,
    };
  }
}
export async function updateLoadType(
    id: number,
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() ?? "",
    orderNumber: parseInt( formData.get("orderNumber")?.toString() ?? "1")
  };  
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);

    if (!validatedFields.success) {
      return {
        success: false,
        errors: mapErrorsToFields(validatedFields.error),
        message: "Missing Fields. Failed to Update Exercise Load Type.",
      };
    }
    const { name ,orderNumber} = validatedFields.data;

    const result = await api.updateExerciseLoadType(id, { id, name ,orderNumber});
    if (result.status == 204)
      return {
        message: "Exercise Load Type updated successfully.",
        success: true,
        defaultValues: defaultValues,
        errors: {},
      };
    else
      return {
        message: "Failed to update exercise load type.",
        success: false,
        errors: {},
        defaultValues: defaultValues,
      };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to update exercise load type.",
      success: false,
      errors: {},
      defaultValues: defaultValues,
    };
  }
}

export async function deleteLoadType(id: number, prevState: State) {
  try {
    await api.deleteExerciseLoadType(id);
    return {
      message: "Exercise Load Type deleted successfully.",
      success: true,
    };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to delete Exercise Load Type.",
      success: false,
    };
  }
}
